export default __webpack_public_path__ + "static/media/thumbnail.adcf4f0f.png";